export type Environment = 'dev' | 'test' | 'prod';

export interface EnvironmentConfig {
  name: string;
  displayName: string;
  scope: string; // MSAL token acquisition scope
}

// Server-provided environment info (fetched from API)
export interface ServerEnvironmentInfo {
  environment: Environment | string;
  osduBaseUrl: string;
  dataPartitionId: string;
}

export const environments: Record<Environment, EnvironmentConfig> = {
  dev: {
    name: 'dev',
    displayName: 'Development',
    scope: 'https://energy.azure.com/.default'
  },
  test: {
    name: 'test',
    displayName: 'Test',
    scope: 'https://energy.azure.com/.default'
  },
  prod: {
    name: 'prod',
    displayName: 'Production',
    scope: 'https://energy.azure.com/.default'
  }
};

export const tenantId = '3aa4a235-b6e2-48d5-9195-7fcf05b459b0'; // Same for all environments

// Helper functions
export const getEnvironmentConfig = (env: Environment): EnvironmentConfig => {
  return environments[env];
};

export const getCurrentEnvironment = (): Environment => {
  const stored = localStorage.getItem('selectedEnvironment') as Environment;
  return stored && stored in environments ? stored : 'dev';
};

export const setCurrentEnvironment = (env: Environment): void => {
  localStorage.setItem('selectedEnvironment', env);
};

// Map environment to backend environment name (Sweden/ADME only)
export const getBackendEnvironmentName = (env: Environment): string => {
  return `adme-${env}`;
}; 